<template>
  <div>
    <vue-action-buttons :buttons="actionButtons" />

    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0">Ajouter une facture au dossier d'importation</h5>
      </div>
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-xl-4 col-12">
            <label for="">Facture <span class="text-danger">*</span></label>
            <vue-select
              :options="costs"
              v-model="selectedCost.cost_reference"
              placeholder="Sélectionner une facture"
              labelColumn="fullName"
              valueColumn="reference"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Total TTC </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.totalPriceTTC"
              class="form-control"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Total HT </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.totalPriceHT"
              class="form-control"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Total TVA </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.totalPriceTVA"
              class="form-control"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">TVA % </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedCost.tva"
              class="form-control"
            />
          </div>
        </div>
        <br />
        <div class="row align-items-end">
          <div class="col-xl-3 col-12">
            <label for="">Méthode de paiement </label>
            <select v-model="selectedCost.paymentMethod" class="form-control">
              <option value="">Sélectionner</option>
              <option value="cash">Espèces</option>
              <option value="cheque">Chèque</option>
              <option value="virement">Virement</option>
              <option value="transfer">Transfert</option>
            </select>
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Date de paiement </label>
            <input
              type="date"
              v-model="selectedCost.paymentDate"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'cheque'"
          >
            <label for="">Numéro de chèque </label>
            <input
              type="text"
              v-model="selectedCost.cheque_number"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'virement'"
          >
            <label for="">Numéro de virement </label>
            <input
              type="text"
              v-model="selectedCost.virement_number"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'virement'"
          >
            <label for="">Date de virement </label>
            <input
              type="date"
              v-model="selectedCost.virementDate"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'transfer'"
          >
            <label for="">Numéro de transfert </label>
            <input
              type="text"
              v-model="selectedCost.transfer_number"
              class="form-control"
            />
          </div>

          <div
            class="col-xl-3 col-12"
            v-if="selectedCost.paymentMethod === 'transfer'"
          >
            <label for="">Date de transfert </label>
            <input
              type="date"
              v-model="selectedCost.transferDate"
              class="form-control"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Numéro de facture </label>
            <input
              type="text"
              v-model="selectedCost.invoice_number"
              class="form-control"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Fournisseur </label>
            <vue-select
              :options="suppliers"
              v-model="selectedCost.supplier_reference"
              placeholder="Sélectionner un fournisseur"
              labelColumn="fullName"
              valueColumn="reference"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">
              Facture
              <span class="badge bg-light text-primary border ms-1" style="font-size:0.7em;">
                <i class="bi bi-stars"></i> IA PDF/Image
              </span>
            </label>
            <div class="d-flex gap-2 align-items-center">
              <input
                type="file"
                ref="invoiceFileInput"
                @change="handleInvoiceFileChange"
                accept=".pdf,.jpg,.jpeg,.png"
                style="display: none"
              />
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="triggerInvoiceFileInput"
                :disabled="isAnalyzingAI"
              >
                <i class="bi bi-upload"></i>
                {{
                  selectedCost.invoice_file
                    ? "Fichier sélectionné"
                    : "Importer"
                }}
              </button>
              <button
                v-if="selectedCost.invoice_file && !isAnalyzingAI"
                type="button"
                class="btn btn-outline-danger"
                @click="removeInvoiceFile"
              >
                <i class="bi bi-x"></i>
              </button>
              <span v-if="isAnalyzingAI" class="d-flex align-items-center text-primary gap-1">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <small>Analyse IA en cours...</small>
              </span>
            </div>
            <small v-if="selectedCost.invoice_file && !isAnalyzingAI" class="text-muted d-block mt-1">
              <i class="bi bi-paperclip"></i> {{ selectedCost.invoice_file.name }}
            </small>
            <small v-if="!selectedCost.invoice_file && !isAnalyzingAI" class="text-muted d-block mt-1">
              PDF, JPG ou PNG — le formulaire sera rempli automatiquement
            </small>
            <small v-if="aiAnalysisError" class="text-warning d-block mt-1">
              <i class="bi bi-exclamation-triangle"></i> {{ aiAnalysisError }}
            </small>
          </div>

          <div class="col-xl-12 col-12">
            <label for="">Remarque </label>
            <textarea
              v-model="selectedCost.remark"
              class="form-control"
            ></textarea>
          </div>

          <div class="col-xl-auto col">
            <label for=""></label>
            <button class="btn btn-success" @click="addCost()" v-if="!editingCostReference">
              <i class="bi bi-plus-circle"></i> Ajouter la facture
            </button>
            <button class="btn btn-warning" @click="addCost()" v-else>
              <i class="bi bi-pencil"></i> Modifier la facture
            </button>
            <button class="btn btn-secondary ms-2" @click="cancelEditCost()" v-if="editingCostReference">
              <i class="bi bi-x"></i> Annuler
            </button>
          </div>
        </div>
      </div>
    </div>

    <vue-data-table
      :headers="headers"
      :data="consignmentCosts"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :show-filter="false"
    >
      <template #cell-cost_reference="{ row }">
        {{ row.costFullName || row.cost_reference }}
      </template>

      <template #cell-invoice_date="{ row }">
        {{ row.invoice_date ? formatDate(row.invoice_date) : "-" }}
      </template>

      <template #cell-invoice_file="{ row }">
        <button
          v-if="row.invoice_file"
          @click="downloadInvoiceFile(row.reference)"
          class="btn btn-sm btn-outline-primary"
          title="Télécharger la facture"
        >
          <i class="bi bi-download"></i> Télécharger
        </button>
        <span v-else class="text-muted">-</span>
      </template>

      <template #cell-totalPriceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-totalPriceHT="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceHT > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceHT }}
        </span>
      </template>

      <template #cell-totalPriceTVA="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceTVA > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTVA }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>
    </vue-data-table>
    <br />

    <!-- Consignment Items Section -->
    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0">Ajouter un article au dossier d'importation</h5>
      </div>
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-xl-2 col-12">
            <label for="">Article <span class="text-danger">*</span></label>
            <vue-select
              :options="items"
              v-model="selectedItem.item_reference"
              placeholder="Sélectionner un article"
              labelColumn="fullName"
              valueColumn="reference"
            />
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Devise </label>
            <select v-model="selectedItem.currency" class="form-control">
              <option value="MAD">MAD</option>
              <option value="EURO">EURO</option>
              <option value="USD">USD</option>
            </select>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Taux de change </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.exchange_rate"
              class="form-control"
              placeholder="1.00"
            />
          </div>

          <div class="col-xl-2 col-12" v-if="selectedItem.currency !== 'MAD' || editingItemId">
            <label for=""
              >Montant total HT en {{ selectedItem.currency }}
            </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.amount_currency"
              class="form-control"
              :placeholder="`Total HT en ${selectedItem.currency}`"
            />
            <small
              class="text-success fw-bold"
              v-if="selectedItem.amount_currency"
            >
              =
              {{
                (
                  parseFloat(selectedItem.amount_currency) *
                  parseFloat(selectedItem.exchange_rate || 1)
                ).toFixed(2)
              }}
              MAD (Total HT)
            </small>
          </div>

          <div class="col-xl-2 col-12" v-if="editingItemId">
            <label for="">Total HT (MAD) </label>
            <input
              type="number"
              step="0.01"
              :value="(parseFloat(selectedItem.priceHT || 0) * parseFloat(selectedItem.quantity || 0)).toFixed(2)"
              class="form-control bg-light"
              placeholder="Total HT en MAD"
              readonly
            />
            <small class="text-muted">
              = Prix HT × Quantité
            </small>
          </div>

          <div class="col-xl-2 col-12" v-if="editingItemId">
            <label for="">Total TTC (MAD) </label>
            <input
              type="number"
              step="0.01"
              :value="(parseFloat(selectedItem.priceTTC || 0) * parseFloat(selectedItem.quantity || 0)).toFixed(2)"
              class="form-control bg-light"
              placeholder="Total TTC en MAD"
              readonly
            />
            <small class="text-muted">
              = Prix TTC × Quantité
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Prix unitaire HT (MAD) </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.priceHT"
              class="form-control"
              placeholder="Prix unitaire HT en MAD"
              readonly
            />
            <small class="text-muted" v-if="selectedItem.priceHT">
              = Total HT / Quantité
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Prix unitaire TTC (MAD) </label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.priceTTC"
              class="form-control"
              placeholder="Prix unitaire TTC en MAD"
              readonly
            />
            <small class="text-muted" v-if="selectedItem.priceTTC">
              Calculé automatiquement
            </small>
          </div>

          <div class="col-xl-2 col-12">
            <label for="">Quantité <span class="text-danger">*</span></label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.quantity"
              class="form-control"
            />
          </div>
        </div>
        <div
          class="row mt-2"
          v-if="selectedItem.currency !== 'MAD' && selectedItem.amount_currency"
        >
          <div class="col-xl-12">
            <div class="alert alert-info">
              <strong>Conversion automatique:</strong>
              <span v-if="selectedItem.amount_currency">
                Montant HT: {{ selectedItem.amount_currency }}
                {{ selectedItem.currency }} × {{ selectedItem.exchange_rate }} =
                {{
                  (
                    parseFloat(selectedItem.amount_currency || 0) *
                    parseFloat(selectedItem.exchange_rate || 1)
                  ).toFixed(2)
                }}
                MAD
              </span>
              <span v-if="selectedItem.priceTTC"> | </span>
              <span v-if="selectedItem.priceTTC">
                Prix TTC: {{ parseFloat(selectedItem.priceTTC).toFixed(2) }} MAD
              </span>
            </div>
          </div>
        </div>
        <br />
        <div class="row align-items-end">
          <div class="col-xl-3 col-12">
            <label for="">Marge bénéficiaire %</label>
            <input
              type="number"
              step="0.01"
              v-model="selectedItem.profit_margin"
              class="form-control"
              placeholder="7.00"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="">Remarque </label>
            <input
              type="text"
              v-model="selectedItem.remark"
              class="form-control"
            />
          </div>

          <div class="col-xl-3 col-12">
            <label for="dum-file-input">
              Fichier DUM / facture fournisseur
              <span class="badge bg-light text-primary border ms-1" style="font-size:0.7em;">
                <i class="bi bi-stars"></i> IA PDF/Image
              </span>
            </label>
            <input
              id="dum-file-input"
              type="file"
              ref="dumFileInput"
              class="form-control"
              accept=".pdf,.jpg,.jpeg,.png"
              style="display: none"
              @change="handleDumFileChange"
            />
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                @click="triggerDumFileInput"
                :disabled="isAnalyzingDumAI"
              >
                <i class="bi bi-upload"></i>
                {{
                  selectedItem.dum_file
                    ? "Fichier sélectionné"
                    : "Importer un fichier"
                }}
              </button>
              <button
                v-if="selectedItem.dum_file && !isAnalyzingDumAI"
                type="button"
                class="btn btn-outline-danger btn-sm"
                @click="removeDumFile"
              >
                <i class="bi bi-x"></i>
              </button>
              <span v-if="isAnalyzingDumAI" class="d-flex align-items-center text-primary gap-1">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <small>Analyse IA en cours...</small>
              </span>
            </div>
            <small v-if="selectedItem.dum_file && !isAnalyzingDumAI" class="text-muted d-block mt-1">
              <i class="bi bi-paperclip"></i> {{ selectedItem.dum_file.name }}
            </small>
            <small v-if="!selectedItem.dum_file && !isAnalyzingDumAI" class="text-muted d-block mt-1">
              PDF, JPG ou PNG — les articles seront ajoutés automatiquement
            </small>
            <small v-if="dumAiAnalysisError" class="text-warning d-block mt-1">
              <i class="bi bi-exclamation-triangle"></i> {{ dumAiAnalysisError }}
            </small>
          </div>

          <div class="col-xl-auto col">
            <label for=""></label>
            <button class="btn btn-success" @click="addItem()" v-if="!editingItemId">
              <i class="bi bi-plus-circle"></i> Ajouter l'article
            </button>
            <button class="btn btn-warning" @click="addItem()" v-else>
              <i class="bi bi-pencil"></i> Modifier l'article
            </button>
            <button class="btn btn-secondary ms-2" @click="cancelEditItem()" v-if="editingItemId">
              <i class="bi bi-x"></i> Annuler
            </button>
          </div>
        </div>
      </div>
    </div>

    <vue-data-table
      :headers="itemHeaders"
      :data="consignmentItems"
      :items-per-page="10"
      :buttons="itemButtons"
      :summable-columns="itemSummableColumns"
      :show-filter="false"
    >
      <template #cell-item_reference="{ row }">
        {{
          row.itemFullName ||
          (row.item && row.item.fullName) ||
          row.item_reference
        }}
      </template>

      <template #cell-amount_mad="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            getAmountMAD(row) > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ getAmountMAD(row).toFixed(2) }}
        </span>
      </template>

      <template #cell-profit_margin="{ row }">
        <span class="px-2 py-1 rounded bg-light-info text-info fw-bold">
          {{ parseFloat(row.profit_margin || 7.0).toFixed(2) }}%
        </span>
      </template>

      <template #cell-priceArticle="{ row }">
        <span
          class="px-2 py-1 rounded bg-light-warning text-warning fw-bold"
        >
          {{ getPriceArticle(row).toFixed(2) }} MAD
        </span>
      </template>

      <template #cell-sellingPrice="{ row }">
        <span
          class="px-2 py-1 rounded bg-light-success text-success fw-bold"
        >
          {{ getSellingPrice(row).toFixed(2) }} MAD
        </span>
      </template>

      <template #cell-priceHT="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.priceHT > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.priceHT }}
        </span>
      </template>

      <template #cell-priceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.priceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.priceTTC }}
        </span>
      </template>

      <template #cell-totalPriceHT="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceHT > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceHT }}
        </span>
      </template>

      <template #cell-totalPriceTTC="{ row }">
        <span
          class="px-2 py-1 rounded"
          :class="
            row.totalPriceTTC > 0
              ? 'bg-light-primary text-primary'
              : 'bg-light-danger text-danger'
          "
        >
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #footer-totalPriceHT="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>
    </vue-data-table>
    <br />

    <!-- Calculation Summary Card (if multiple items) -->
    <div
      class="card mb-3"
      v-if="consignmentItemsCount > 1 && (consignmentCosts.length > 0 || consignmentItems.length > 0)"
    >
      <div class="card-header bg-info text-white">
        <h5 class="mb-0">Calcul de la facture par article (factures uniquement)</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <strong>Total des factures HT (sans articles) :</strong>
            <span class="ms-2 text-primary fw-bold">
              {{ totalCostsOnlyHT.toFixed(2) }} MAD
            </span>
          </div>
          <div class="col-md-6">
            <strong>Nombre d'articles:</strong>
            <span class="ms-2 text-primary fw-bold">
              {{ consignmentItemsCount }}
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <strong>Facture par article (Total factures / Nombre d'articles) :</strong>
            <span class="ms-2 text-warning fw-bold fs-5">
              {{ costPerItemFromCosts.toFixed(2) }} MAD
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3 col-12">
        <label for="">Société <span class="text-danger">*</span> </label>

        <vue-select
          :options="societies"
          v-model="consignment.society_reference"
          placeholder="Select an option"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Fournisseur</label>
        <vue-select
          :options="suppliers"
          v-model="consignment.supplier_reference"
          placeholder="Optionnel"
          labelColumn="fullName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Date<span class="text-danger">*</span></label>
        <input type="date" v-model="consignment.date" class="form-control" />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Taux de change<span class="text-danger">*</span></label>
        <input
          type="number"
          step="0.01"
          v-model="consignment.exchange_rate"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Marge bénéficiaire %</label>
        <input
          type="number"
          step="0.01"
          v-model="consignment.profit_margin"
          class="form-control"
          placeholder="7.00"
        />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-12 col-12">
        <label for=""> Remarque </label>
        <textarea v-model="consignment.remark" class="form-control"></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12"></div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="save(consignment)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import constant from "../../constant";

export default {
  data() {
    return {
      reference: this.$route.params.reference,
      accept: false,
      actionButtons: [
        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: () => this.refresh(),
        },
      ],

      headers: [
        { field: "cost_reference", label: "Facture", class: "" },
        { field: "invoice_number", label: "N° Facture", class: "" },
        { field: "invoice_date", label: "Date Facture", class: "" },
        { field: "supplierFullName", label: "Fournisseur", class: "" },
        { field: "invoice_file", label: "Facture", class: "" },
        {
          field: "totalPriceTTC",
          label: "Total TTC",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "totalPriceHT",
          label: "Total HT",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "totalPriceTVA",
          label: "Total TVA",
          class: "fw-bold",
          isAmount: true,
        },
        { field: "tva", label: "TVA %", class: "" },
        { field: "paymentMethod", label: "Méthode de paiement", class: "" },
        { field: "paymentDate", label: "Date de paiement", class: "" },
        { field: "userFullName", label: "Créer par", class: "" },
      ],
      selectedCost: {
        cost_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        invoice_number: "",
        supplier_reference: "",
        invoice_file: null,
        remark: "",
      },
      editingCostReference: null,
      isCalculating: false,
      isAnalyzingAI: false,
      aiAnalysisError: null,
      isAnalyzingDumAI: false,
      dumAiAnalysisError: null,
      buttons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (item) => {
            this.editCost(item);
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (item) => {
            this.deleteCost(item);
          },
        },
      ],
      summableColumns: [
        { field: "totalPriceTTC", class: "fw-bold" },
        { field: "totalPriceHT", class: "fw-bold" },
        { field: "totalPriceTVA", class: "fw-bold" },
      ],
      itemHeaders: [
        { field: "item_reference", label: "Article", class: "" },
        { field: "currency", label: "Devise", class: "" },
        {
          field: "exchange_rate",
          label: "Taux de change",
          class: "",
          isAmount: true,
        },
        {
          field: "amount_currency",
          label: "Montant (Devise)",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "amount_mad",
          label: "Montant (MAD)",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "priceHT",
          label: "Prix HT",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "priceTTC",
          label: "Prix TTC",
          class: "fw-bold",
          isAmount: true,
        },
        { field: "quantity", label: "Quantité", class: "fw-bold" },
        {
          field: "totalPriceHT",
          label: "Total HT",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "totalPriceTTC",
          label: "Total TTC",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "profit_margin",
          label: "Marge %",
          class: "fw-bold",
          isAmount: true,
        },
        {
          field: "priceArticle",
          label: "Prix article",
          class: "fw-bold text-warning",
          isAmount: true,
        },
        {
          field: "sellingPrice",
          label: "Prix de vente",
          class: "fw-bold text-success",
          isAmount: true,
        },
        { field: "remark", label: "Remarque", class: "" },
        { field: "userFullName", label: "Créé par", class: "" },
      ],
      selectedItem: {
        item_reference: "",
        currency: "MAD",
        exchange_rate: 1,
        amount_currency: "",
        priceHT: "",
        priceTTC: "",
        quantity: "",
        profit_margin: 7.0,
        remark: "",
        dum_file: null,
        dum_existing_path: "",
      },
      editingItemId: null,
      itemButtons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (item) => {
            this.editItem(item);
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (item) => {
            this.deleteItem(item);
          },
        },
      ],
      itemSummableColumns: [
        { field: "totalPriceHT", class: "fw-bold" },
        { field: "totalPriceTTC", class: "fw-bold" },
        { field: "quantity", class: "fw-bold" },
      ],
    };
  },
  computed: {
    ...mapGetters("consignment", {
      consignment: "getConsignment",
    }),
    ...mapGetters("society", {
      societies: "getAll",
    }),
    ...mapGetters("cost", {
      costs: "getAll",
    }),
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    // Get costs linked to this consignment
    consignmentCosts() {
      if (!this.consignment || !this.consignment.consignmentCosts) return [];
      return this.consignment.consignmentCosts;
    },
    // Get items linked to this consignment
    consignmentItems() {
      if (!this.consignment || !this.consignment.consignmentItems) return [];
      return this.consignment.consignmentItems;
    },
    // Count of consignment items
    consignmentItemsCount() {
      if (!this.consignmentItems || this.consignmentItems.length === 0) return 0;
      return this.consignmentItems.length;
    },
    // Total costs HT (without items) - sum of all consignment_costs only
    totalCostsOnlyHT() {
      if (!this.consignmentCosts || this.consignmentCosts.length === 0) return 0;
      return this.consignmentCosts.reduce(
        (sum, cost) => sum + parseFloat(cost.totalPriceHT || 0),
        0
      );
    },
    // Cost per item from costs only (if multiple items)
    costPerItemFromCosts() {
      if (this.consignmentItemsCount <= 1) return 0;
      if (this.consignmentItemsCount === 0) return 0;
      return this.totalCostsOnlyHT / this.consignmentItemsCount;
    },
  },
  methods: {
    async save(data) {
      // Validate required fields
      if (!data.society_reference) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner une société.",
        });
        return;
      }

      if (!data.date) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner une date.",
        });
        return;
      }

      if (!data.exchange_rate || data.exchange_rate <= 0) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Le taux de change doit être supérieur à 0.",
        });
        return;
      }

      await this.$store.dispatch("consignment/update", data);
    },
    async refresh() {
      await this.$store.dispatch("society/getAll");
      await this.$store.dispatch("cost/getAll");
      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("supplier/getAll");
      await this.$store.dispatch("consignment/show", this.reference);
    },
    async editCost(item) {
      // Populate form with cost data
      this.editingCostReference = item.reference;
      this.selectedCost = {
        cost_reference: item.cost_reference || "",
        totalPriceTTC: item.totalPriceTTC || "",
        totalPriceHT: item.totalPriceHT || "",
        totalPriceTVA: item.totalPriceTVA || "",
        tva: item.tva || "",
        paymentMethod: item.paymentMethod || "",
        paymentDate: item.paymentDate || "",
        cheque_number: item.cheque_number || "",
        virement_number: item.virement_number || "",
        virementDate: item.virementDate || "",
        transfer_number: item.transfer_number || "",
        transferDate: item.transferDate || "",
        invoice_number: item.invoice_number || "",
        supplier_reference: item.supplier_reference || "",
        invoice_file: null, // File can't be pre-filled
        remark: item.remark || "",
      };
      // Scroll to form
      this.$nextTick(() => {
        const formElement = document.querySelector('.card.mb-3');
        if (formElement) {
          formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    cancelEditCost() {
      this.editingCostReference = null;
      this.selectedCost = {
        cost_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        invoice_number: "",
        supplier_reference: "",
        invoice_file: null,
        remark: "",
      };
    },
    async deleteCost(item) {
      await this.$store.dispatch("consignment/destroyCost", item.reference);
      await this.refresh();
    },
    async addCost() {
      if (!this.selectedCost.cost_reference) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner une facture.",
        });
        return;
      }

      // Check if we're editing or creating
      if (this.editingCostReference) {
        // Update existing cost
        const updateData = {
          reference: this.editingCostReference,
          cost_reference: this.selectedCost.cost_reference,
        };
        
        if (this.selectedCost.totalPriceTTC)
          updateData.totalPriceTTC = this.selectedCost.totalPriceTTC;
        if (this.selectedCost.totalPriceHT)
          updateData.totalPriceHT = this.selectedCost.totalPriceHT;
        if (this.selectedCost.totalPriceTVA)
          updateData.totalPriceTVA = this.selectedCost.totalPriceTVA;
        if (this.selectedCost.tva) updateData.tva = this.selectedCost.tva;
        if (this.selectedCost.paymentMethod)
          updateData.paymentMethod = this.selectedCost.paymentMethod;
        if (this.selectedCost.paymentDate)
          updateData.paymentDate = this.selectedCost.paymentDate;
        if (this.selectedCost.cheque_number)
          updateData.cheque_number = this.selectedCost.cheque_number;
        if (this.selectedCost.virement_number)
          updateData.virement_number = this.selectedCost.virement_number;
        if (this.selectedCost.virementDate)
          updateData.virementDate = this.selectedCost.virementDate;
        if (this.selectedCost.transfer_number)
          updateData.transfer_number = this.selectedCost.transfer_number;
        if (this.selectedCost.transferDate)
          updateData.transferDate = this.selectedCost.transferDate;
        if (this.selectedCost.invoice_number)
          updateData.invoice_number = this.selectedCost.invoice_number;
        if (this.selectedCost.supplier_reference)
          updateData.supplier_reference = this.selectedCost.supplier_reference;
        if (this.selectedCost.remark)
          updateData.remark = this.selectedCost.remark;

        await this.$store.dispatch("consignment/updateCost", updateData);
        this.editingCostReference = null;
        await this.refresh();
        // Navigate to details page after editing
        this.$router.push({
          name: "consignments-details",
          params: { reference: this.reference },
        });
      } else {
        // Create new cost
        const formData = new FormData();

        // Append all cost data
        formData.append("cost_reference", this.selectedCost.cost_reference);
        formData.append("consignment_reference", this.reference); // Link to current consignment
        if (this.selectedCost.totalPriceTTC)
          formData.append("totalPriceTTC", this.selectedCost.totalPriceTTC);
        if (this.selectedCost.totalPriceHT)
          formData.append("totalPriceHT", this.selectedCost.totalPriceHT);
        if (this.selectedCost.totalPriceTVA)
          formData.append("totalPriceTVA", this.selectedCost.totalPriceTVA);
        if (this.selectedCost.tva) formData.append("tva", this.selectedCost.tva);
        if (this.selectedCost.paymentMethod)
          formData.append("paymentMethod", this.selectedCost.paymentMethod);
        if (this.selectedCost.paymentDate)
          formData.append("paymentDate", this.selectedCost.paymentDate);
        if (this.selectedCost.cheque_number)
          formData.append("cheque_number", this.selectedCost.cheque_number);
        if (this.selectedCost.virement_number)
          formData.append("virement_number", this.selectedCost.virement_number);
        if (this.selectedCost.virementDate)
          formData.append("virementDate", this.selectedCost.virementDate);
        if (this.selectedCost.transfer_number)
          formData.append("transfer_number", this.selectedCost.transfer_number);
        if (this.selectedCost.transferDate)
          formData.append("transferDate", this.selectedCost.transferDate);
        if (this.selectedCost.invoice_number)
          formData.append("invoice_number", this.selectedCost.invoice_number);
        if (this.selectedCost.supplier_reference)
          formData.append(
            "supplier_reference",
            this.selectedCost.supplier_reference
          );
        if (this.selectedCost.remark)
          formData.append("remark", this.selectedCost.remark);

        // Append invoice file if selected
        if (this.selectedCost.invoice_file) {
          formData.append("invoice_file", this.selectedCost.invoice_file);
        }

        await this.$store.dispatch("consignment/storeCost", formData);
        await this.refresh();
      }

      // Reset the form
      this.selectedCost = {
        cost_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        invoice_number: "",
        supplier_reference: "",
        invoice_file: null,
        remark: "",
      };
    },
    triggerInvoiceFileInput() {
      this.$refs.invoiceFileInput.click();
    },
    handleInvoiceFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedCost.invoice_file = file;
        this.aiAnalysisError = null;
        if (file.type.startsWith('image/') || file.type === 'application/pdf') {
          this.analyzeInvoiceWithAI(file);
        }
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async loadPdfJs() {
      if (window.pdfjsLib) return window.pdfjsLib;
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
        script.onload = () => {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc =
            'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
          resolve(window.pdfjsLib);
        };
        script.onerror = () => reject(new Error('Impossible de charger pdf.js'));
        document.head.appendChild(script);
      });
    },
    async pdfFileToBase64Image(file) {
      const pages = await this.pdfToAllPagesBase64(file, 1);
      return pages[0];
    },
    async pdfToAllPagesBase64(file, maxPages = 20) {
      const pdfjsLib = await this.loadPdfJs();
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const total = Math.min(pdf.numPages, maxPages);
      const result = [];
      for (let i = 1; i <= total; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 2.0 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');
        await page.render({ canvasContext: ctx, viewport }).promise;
        result.push(canvas.toDataURL('image/jpeg', 0.85));
      }
      return result;
    },
    async analyzeInvoiceWithAI(file) {
      this.isAnalyzingAI = true;
      this.aiAnalysisError = null;
      try {
        let base64;
        if (file.type === 'application/pdf') {
          base64 = await this.pdfFileToBase64Image(file);
        } else {
          base64 = await this.fileToBase64(file);
        }
        const apiKey = this.$setting('groq_api_key') || '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';
        const prompt = `Analyse cette image de facture et extrais les informations suivantes sous forme d'objet JSON uniquement (sans explication ni markdown, juste le JSON brut) :
{
  "totalPriceTTC": <montant total TTC (nombre) ou null>,
  "totalPriceHT": <montant hors taxe (nombre) ou null>,
  "totalPriceTVA": <montant de la TVA (nombre) ou null>,
  "tva": <taux de TVA en pourcentage ex: 20 (nombre) ou null>,
  "invoice_number": "<numéro de facture ou chaîne vide>",
  "paymentDate": "<date au format YYYY-MM-DD ou chaîne vide>",
  "paymentMethod": "<cash ou cheque ou virement ou transfer ou chaîne vide>",
  "remark": "<remarque contextuelle ou chaîne vide>",
  "supplier_name": "<nom complet du fournisseur/vendeur émetteur de la facture ou chaîne vide>",
  "cost_name": "<type ou catégorie du coût ex: Transport, Douane, Transitaire, Assurance, Frais bancaires ou chaîne vide>"
}
Si un champ n'est pas visible dans la facture, utilise null pour les nombres et une chaîne vide pour les chaînes.`;
        const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            model: 'meta-llama/llama-4-scout-17b-16e-instruct',
            messages: [
              {
                role: 'user',
                content: [
                  { type: 'text', text: prompt },
                  { type: 'image_url', image_url: { url: base64 } },
                ],
              },
            ],
            max_tokens: 512,
            temperature: 0.1,
          }),
        });
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.error && errData.error.message ? errData.error.message : `Erreur API Groq (${response.status})`);
        }
        const data = await response.json();
        const content = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;
        if (!content) throw new Error('Réponse vide de l\'IA');
        const jsonStr = content.replace(/```json\s*/g, '').replace(/```\s*/g, '').trim();
        let extracted;
        try {
          extracted = JSON.parse(jsonStr);
        } catch (e) {
          throw new Error('Impossible de parser la réponse JSON de l\'IA');
        }
        if (extracted.totalPriceTTC != null) this.selectedCost.totalPriceTTC = extracted.totalPriceTTC;
        if (extracted.totalPriceHT != null) this.selectedCost.totalPriceHT = extracted.totalPriceHT;
        if (extracted.totalPriceTVA != null) this.selectedCost.totalPriceTVA = extracted.totalPriceTVA;
        if (extracted.tva != null) this.selectedCost.tva = extracted.tva;
        if (extracted.invoice_number) this.selectedCost.invoice_number = extracted.invoice_number;
        if (extracted.paymentDate) this.selectedCost.paymentDate = extracted.paymentDate;
        if (extracted.paymentMethod) this.selectedCost.paymentMethod = extracted.paymentMethod;
        if (extracted.remark) this.selectedCost.remark = extracted.remark;

        const autoCreated = [];

        if (extracted.supplier_name) {
          const supplierName = extracted.supplier_name.trim().toUpperCase();
          const existingSupplier = this.suppliers.find(
            (s) => s.fullName && s.fullName.toUpperCase() === supplierName
          );
          if (existingSupplier) {
            this.selectedCost.supplier_reference = existingSupplier.reference;
          } else {
            try {
              const res = await this.$api.instance.post('suppliers', { society: supplierName });
              const newSupplier = res.data && (res.data.data || res.data);
              if (newSupplier && newSupplier.reference) {
                await this.$store.dispatch('supplier/getAll');
                await this.$nextTick();
                this.selectedCost.supplier_reference = newSupplier.reference;
                autoCreated.push(`Fournisseur "${supplierName}" créé`);
              }
            } catch (e) {
              console.warn('Auto-create supplier failed:', e);
            }
          }
        }

        if (extracted.cost_name) {
          const costName = extracted.cost_name.trim().toUpperCase();
          const existingCost = this.costs.find(
            (c) => c.fullName && c.fullName.toUpperCase() === costName
          );
          if (existingCost) {
            this.selectedCost.cost_reference = existingCost.reference;
          } else {
            try {
              const res = await this.$api.instance.post('costs', { fullName: costName, tva: extracted.tva || 0, is_importation: true });
              const newCost = res.data && (res.data.data || res.data);
              if (newCost && newCost.reference) {
                await this.$store.dispatch('cost/getAll');
                await this.$nextTick();
                this.selectedCost.cost_reference = newCost.reference;
                autoCreated.push(`Coût "${costName}" créé`);
              }
            } catch (e) {
              console.warn('Auto-create cost failed:', e);
            }
          }
        }

        const extra = autoCreated.length ? ` (${autoCreated.join(', ')})` : '';
        await this.$store.dispatch('notification/store', {
          status: 'success',
          message: `Formulaire rempli automatiquement par l'IA Groq.${extra}`,
        });
      } catch (error) {
        console.error('Groq AI analysis error:', error);
        this.aiAnalysisError = error.message || 'Analyse IA échouée';
        await this.$store.dispatch('notification/store', {
          status: 'warning',
          message: 'Analyse IA échouée : ' + (error.message || 'erreur inconnue'),
        });
      } finally {
        this.isAnalyzingAI = false;
      }
    },
    removeInvoiceFile() {
      this.selectedCost.invoice_file = null;
      this.aiAnalysisError = null;
      if (this.$refs.invoiceFileInput) {
        this.$refs.invoiceFileInput.value = "";
      }
    },
    triggerDumFileInput() {
      if (this.$refs.dumFileInput) {
        this.$refs.dumFileInput.click();
      }
    },
    handleDumFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      this.selectedItem.dum_file = file;
      this.dumAiAnalysisError = null;
      if (file.type.startsWith('image/') || file.type === 'application/pdf') {
        this.analyzeItemWithAI(file);
      }
    },
    removeDumFile() {
      this.selectedItem.dum_file = null;
      this.dumAiAnalysisError = null;
      if (this.$refs.dumFileInput) {
        this.$refs.dumFileInput.value = "";
      }
    },
    async analyzeItemWithAI(file) {
      this.isAnalyzingDumAI = true;
      this.dumAiAnalysisError = null;
      try {
        let images = [];
        if (file.type === 'application/pdf') {
          images = await this.pdfToAllPagesBase64(file, 20);
        } else {
          images = [await this.fileToBase64(file)];
        }

        const apiKey = this.$setting('groq_api_key') || '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';

        const prompt = `Tu reçois une ou plusieurs pages d'une facture fournisseur.
Extrais TOUTES les lignes de produits/marchandises présentes dans ces pages et retourne un tableau JSON uniquement (sans explication ni markdown, juste le tableau JSON brut).
Chaque élément du tableau doit avoir cette structure :
{
  "item_name": "<désignation exacte de l'article tel qu'il apparaît sur la facture, ou chaîne vide>",
  "measuring": "<unité de mesure parmi : M3, M2, Qx, Kg, PCS, M — ou chaîne vide>",
  "currency": "<devise : MAD, EURO ou USD — MAD si non précisée>",
  "exchange_rate": <taux de change numérique, 1 par défaut>,
  "amount_currency": <montant total HT de la ligne dans la devise (nombre) ou null>,
  "quantity": <quantité de la ligne (nombre) ou null>,
  "quantity_pcs": <quantité en pièces si précisée (nombre) ou null>,
  "remark": "<description complémentaire ou chaîne vide>"
}
Règles :
- Une ligne par article distinct — ne regroupe pas plusieurs articles.
- Si la facture ne contient qu'un seul article, retourne un tableau avec un seul élément.
- Ignore les lignes de totaux, taxes, frais, remises — uniquement les lignes produits.
- Si un champ est introuvable, utilise null pour les nombres et chaîne vide pour les chaînes.`;

        const contentParts = [{ type: 'text', text: prompt }];
        for (const img of images) {
          contentParts.push({ type: 'image_url', image_url: { url: img } });
        }

        const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            model: 'meta-llama/llama-4-scout-17b-16e-instruct',
            messages: [{ role: 'user', content: contentParts }],
            max_tokens: 2048,
            temperature: 0.1,
          }),
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.error && errData.error.message ? errData.error.message : `Erreur API Groq (${response.status})`);
        }
        const data = await response.json();
        const content = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;
        if (!content) throw new Error('Réponse vide de l\'IA');

        const jsonStr = content.replace(/```json\s*/g, '').replace(/```\s*/g, '').trim();
        let extractedList;
        try {
          extractedList = JSON.parse(jsonStr);
        } catch (e) {
          throw new Error('Impossible de parser la réponse JSON de l\'IA');
        }

        if (!Array.isArray(extractedList)) extractedList = [extractedList];
        if (extractedList.length === 0) throw new Error('Aucun article trouvé dans la facture');

        let addedCount = 0;
        let skippedCount = 0;

        for (const extracted of extractedList) {
          this.selectedItem = {
            item_reference: '',
            currency: extracted.currency && ['MAD', 'EURO', 'USD'].includes(extracted.currency) ? extracted.currency : 'MAD',
            exchange_rate: extracted.exchange_rate != null ? extracted.exchange_rate : 1,
            amount_currency: '',
            priceHT: '',
            priceTTC: '',
            quantity: extracted.quantity != null ? extracted.quantity : '',
            profit_margin: 7.0,
            remark: extracted.remark || '',
            dum_file: this.selectedItem.dum_file,
            dum_existing_path: '',
          };

          if (extracted.item_name) {
            const itemName = extracted.item_name.trim().toUpperCase();
            const existingItem = this.items.find(
              (i) => i.fullName && i.fullName.toUpperCase() === itemName
            );
            if (existingItem) {
              this.selectedItem.item_reference = existingItem.reference;
            } else {
              try {
                const res = await this.$api.instance.post('items', {
                  fullName: itemName,
                  measuring: extracted.measuring || '',
                });
                const newRef = res.data && (typeof res.data.data === 'string' ? res.data.data : null);
                if (newRef) {
                  await this.$store.dispatch('item/getAll');
                  await this.$nextTick();
                  this.selectedItem.item_reference = newRef;
                }
              } catch (e) {
                console.warn('Auto-create item failed:', e);
              }
            }
          }

          if (extracted.amount_currency != null) {
            await this.$nextTick();
            this.selectedItem.amount_currency = extracted.amount_currency;
          }

          const canSave =
            this.selectedItem.item_reference &&
            parseFloat(this.selectedItem.quantity) > 0 &&
            this.selectedItem.amount_currency;

          if (canSave) {
            await this.$nextTick();
            await this.addItem();
            addedCount++;
          } else {
            skippedCount++;
          }
        }

        const msg = addedCount > 0
          ? `${addedCount} article(s) ajouté(s) automatiquement depuis la facture fournisseur.`
            + (skippedCount > 0 ? ` ${skippedCount} ligne(s) ignorée(s) (données incomplètes).` : '')
          : 'Formulaire rempli par l\'IA — vérifiez les champs manquants puis cliquez sur Ajouter.';

        await this.$store.dispatch('notification/store', { status: 'success', message: msg });
      } catch (error) {
        console.error('Groq DUM AI analysis error:', error);
        this.dumAiAnalysisError = error.message || 'Analyse IA échouée';
        await this.$store.dispatch('notification/store', {
          status: 'warning',
          message: 'Analyse IA échouée : ' + (error.message || 'erreur inconnue'),
        });
      } finally {
        this.isAnalyzingDumAI = false;
      }
    },
    async addItem() {
      if (!this.selectedItem.item_reference) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez sélectionner un article.",
        });
        return;
      }

      if (
        !this.selectedItem.quantity ||
        parseFloat(this.selectedItem.quantity) <= 0
      ) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "La quantité doit être supérieure à 0.",
        });
        return;
      }

      if (!this.selectedItem.amount_currency) {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Veuillez entrer un montant en devise.",
        });
        return;
      }

      // Convert amount in currency to MAD for totals
      const exchangeRate = parseFloat(this.selectedItem.exchange_rate) || 1;
      const currency = this.selectedItem.currency || "MAD";
      const quantity = parseFloat(this.selectedItem.quantity);

      // Convert total to MAD
      const totalPriceHT =
        currency === "MAD"
          ? parseFloat(this.selectedItem.amount_currency)
          : parseFloat(this.selectedItem.amount_currency) * exchangeRate;

      // Calculate totalPriceTTC based on item's TVA
      let totalPriceTTC = totalPriceHT;
      if (this.selectedItem.item_reference) {
        const item = this.items.find(
          (item) => item.reference === this.selectedItem.item_reference
        );
        if (item && item.tva !== null && item.tva !== undefined) {
          const tva = parseFloat(item.tva) || 0;
          if (tva > 0) {
            const totalTVA = totalPriceHT * (tva / 100);
            totalPriceTTC = totalPriceHT + totalTVA;
          }
        }
      }

      // Calculate unit prices = totals / quantity
      const priceHT = totalPriceHT / quantity;
      const priceTTC = totalPriceTTC / quantity;

      // Check if we're editing or creating
      try {
        const currency = this.selectedItem.currency || "MAD";
        const exchangeRate = parseFloat(this.selectedItem.exchange_rate) || 1;
        // Use the amount_currency entered by the user
        const amount_currency_value = parseFloat(this.selectedItem.amount_currency) || 0;

        if (this.editingItemId) {
          // Update existing item
          await this.$store.dispatch("consignment/updateItem", {
            id: this.editingItemId,
            item_reference: this.selectedItem.item_reference,
            currency: currency,
            exchange_rate: exchangeRate,
            amount_currency: amount_currency_value,
            priceHT: priceHT,
            priceTTC: priceTTC,
            quantity: quantity,
            totalPriceHT: totalPriceHT,
            totalPriceTTC: totalPriceTTC,
            profit_margin: parseFloat(this.selectedItem.profit_margin) || 7.0,
            remark: this.selectedItem.remark || "",
          });
          this.editingItemId = null;
          await this.refresh();
          // Navigate to details page after editing
          this.$router.push({
            name: "consignments-details",
            params: { reference: this.reference },
          });
        } else {
          // Store item with consignment reference
          await this.$store.dispatch("consignment/storeItem", {
            item_reference: this.selectedItem.item_reference,
            currency: currency,
            exchange_rate: exchangeRate,
            amount_currency: amount_currency_value,
            priceHT: priceHT,
            priceTTC: priceTTC,
            quantity: quantity,
            totalPriceHT: totalPriceHT,
            totalPriceTTC: totalPriceTTC,
            profit_margin: parseFloat(this.selectedItem.profit_margin) || 7.0,
            remark: this.selectedItem.remark || "",
            consignment_reference: this.reference, // Link to current consignment
          });
          await this.refresh();
        }

        // Reset the form
        this.selectedItem = {
          item_reference: "",
          currency: "MAD",
          exchange_rate: 1,
          amount_currency: "",
          priceHT: "",
          priceTTC: "",
          quantity: "",
          profit_margin: 7.0,
          remark: "",
          dum_file: null,
          dum_existing_path: "",
        };
      } catch (error) {
        console.error("Error adding/updating item:", error);
        await this.$store.dispatch("notification/store", {
          status: "error",
          message:
            "Erreur lors de l'ajout/modification de l'article: " +
            (error.message || "Erreur inconnue"),
        });
      }
    },
    async editItem(item) {
      // Pre-fill the form with item data
      this.editingItemId = item.id;
      const currency = item.currency || "MAD";
      const exchangeRate = parseFloat(item.exchange_rate) || 1;
      const priceHT_MAD = parseFloat(item.priceHT) || 0;
      const priceTTC_MAD = parseFloat(item.priceTTC) || 0;
      const quantity = parseFloat(item.quantity) || 1;

      // Use stored amount_currency if available, otherwise calculate it
      let amount_currency = parseFloat(item.amount_currency);
      if (!amount_currency || isNaN(amount_currency)) {
        // Calculate from totalPriceHT if not stored
        const totalPriceHT = priceHT_MAD * quantity;
        amount_currency = currency === "MAD" ? totalPriceHT : totalPriceHT / exchangeRate;
      }

      this.selectedItem = {
        item_reference: item.item_reference,
        currency: currency,
        exchange_rate: exchangeRate,
        amount_currency: amount_currency.toFixed(2),
        priceHT: priceHT_MAD,
        priceTTC: priceTTC_MAD,
        quantity: item.quantity,
        profit_margin: parseFloat(item.profit_margin) || 7.0,
        remark: item.remark || "",
      };

      // Scroll to form
      this.$nextTick(() => {
        const formElements = document.querySelectorAll('.card.mb-3');
        if (formElements[1]) {
          formElements[1].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    cancelEditItem() {
      this.editingItemId = null;
      this.selectedItem = {
        item_reference: "",
        currency: "MAD",
        exchange_rate: 1,
        amount_currency: "",
        priceHT: "",
        priceTTC: "",
        quantity: "",
        profit_margin: 7.0,
        remark: "",
        dum_file: null,
        dum_existing_path: "",
      };
    },
    async deleteItem(item) {
      await this.$store.dispatch("consignment/destroyItem", item.id);
      await this.refresh();
    },
    calculateItemAmounts() {
      // Centralized method to calculate all item amounts
      if (!this.selectedItem.amount_currency) {
        return;
      }

      const exchangeRate = parseFloat(this.selectedItem.exchange_rate) || 1;
      const currency = this.selectedItem.currency || "MAD";
      const quantity = parseFloat(this.selectedItem.quantity) || 1;

      // Convert amount in currency to MAD for totalPriceHT
      const totalPriceHT =
        currency === "MAD"
          ? parseFloat(this.selectedItem.amount_currency)
          : parseFloat(this.selectedItem.amount_currency) * exchangeRate;

      // Calculate totalPriceTTC based on item's TVA
      let totalPriceTTC = totalPriceHT;
      if (this.selectedItem.item_reference) {
        const item = this.items.find(
          (item) => item.reference === this.selectedItem.item_reference
        );
        if (item && item.tva !== null && item.tva !== undefined) {
          const tva = parseFloat(item.tva) || 0;
          if (tva > 0) {
            const totalTVA = totalPriceHT * (tva / 100);
            totalPriceTTC = totalPriceHT + totalTVA;
          }
        }
      }

      // Calculate unit prices = totals / quantity
      if (quantity > 0) {
        this.selectedItem.priceHT = totalPriceHT / quantity;
        this.selectedItem.priceTTC = totalPriceTTC / quantity;
      } else {
        // No quantity yet, show totals as prices (will be divided when quantity is entered)
        this.selectedItem.priceHT = totalPriceHT;
        this.selectedItem.priceTTC = totalPriceTTC;
      }
    },
    formatDate(value) {
      if (!value) return null;
      return moment(value).format("DD-MM-YYYY");
    },
    // Calculate amount in MAD from amount_currency and exchange_rate
    getAmountMAD(item) {
      if (!item.amount_currency) return 0;
      const amountCurrency = parseFloat(item.amount_currency) || 0;
      const exchangeRate = parseFloat(item.exchange_rate) || 1;
      const currency = item.currency || "MAD";

      if (currency === "MAD") {
        return amountCurrency;
      }
      return amountCurrency * exchangeRate;
    },
    // Calculate price per article for each item
    // Formula: (costPerItemFromCosts + item.totalPriceHT) / item.quantity
    getPriceArticle(item) {
      if (this.consignmentItemsCount <= 1) {
        // If only one item, return the regular priceHT
        return parseFloat(item.priceHT || 0);
      }

      const costPerItem = this.costPerItemFromCosts;
      const itemTotalHT = parseFloat(item.totalPriceHT || 0);
      const quantity = parseFloat(item.quantity || 1);

      if (quantity === 0) return 0;

      // Total HT = cost per item (from costs) + item's totalPriceHT
      const totalHT = costPerItem + itemTotalHT;

      // Price article = Total HT / quantity
      return totalHT / quantity;
    },
    // Calculate selling price for each item using item's profit margin
    getSellingPrice(item) {
      const priceArticle = this.getPriceArticle(item);
      const profitMargin = parseFloat(item.profit_margin || 7.0);
      return priceArticle * (1 + profitMargin / 100);
    },
    async downloadInvoiceFile(reference) {
      await this.$store.dispatch("consignment/downloadInvoiceFile", reference);
    },
  },
  watch: {
    "selectedCost.cost_reference": function (newValue) {
      if (newValue) {
        const cost = this.costs.find((cost) => cost.reference === newValue);
        if (cost && cost.tva !== null && cost.tva !== undefined) {
          this.selectedCost.tva = cost.tva;
        }
      } else {
        this.selectedCost.tva = "";
      }
    },
    "selectedCost.totalPriceHT": function (newValue) {
      if (this.isCalculating || !newValue) return;

      this.isCalculating = true;
      const totalHT = parseFloat(newValue) || 0;
      const tva = parseFloat(this.selectedCost.tva) || 0;

      if (totalHT > 0) {
        if (tva === 0 || !tva) {
          this.selectedCost.totalPriceTTC = totalHT.toFixed(2);
          this.selectedCost.totalPriceTVA = "0.00";
        } else {
          const totalTVA = totalHT * (tva / 100);
          const totalTTC = totalHT + totalTVA;

          this.selectedCost.totalPriceTVA = totalTVA.toFixed(2);
          this.selectedCost.totalPriceTTC = totalTTC.toFixed(2);
        }
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
    "selectedCost.totalPriceTTC": function (newValue) {
      if (this.isCalculating || !newValue) return;

      this.isCalculating = true;
      const totalTTC = parseFloat(newValue) || 0;
      const tva = parseFloat(this.selectedCost.tva) || 0;

      if (totalTTC > 0) {
        if (tva === 0 || !tva) {
          this.selectedCost.totalPriceHT = totalTTC.toFixed(2);
          this.selectedCost.totalPriceTVA = "0.00";
        } else {
          const totalHT = totalTTC / (1 + tva / 100);
          const totalTVA = totalTTC - totalHT;

          this.selectedCost.totalPriceHT = totalHT.toFixed(2);
          this.selectedCost.totalPriceTVA = totalTVA.toFixed(2);
        }
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
    "selectedCost.totalPriceTVA": function (newValue) {
      if (this.isCalculating || !newValue) return;

      this.isCalculating = true;
      const totalTVA = parseFloat(newValue) || 0;
      const tva = parseFloat(this.selectedCost.tva) || 0;

      if (totalTVA >= 0) {
        if (tva === 0 || !tva) {
          const totalHT = parseFloat(this.selectedCost.totalPriceHT) || 0;
          if (totalHT > 0) {
            this.selectedCost.totalPriceTTC = totalHT.toFixed(2);
            this.selectedCost.totalPriceTVA = "0.00";
          }
        } else {
          const totalHT = totalTVA / (tva / 100);
          const totalTTC = totalHT + totalTVA;

          this.selectedCost.totalPriceHT = totalHT.toFixed(2);
          this.selectedCost.totalPriceTTC = totalTTC.toFixed(2);
        }
      }

      this.$nextTick(() => {
        this.isCalculating = false;
      });
    },
    "selectedItem.item_reference": function (newValue) {
      if (newValue) {
        const item = this.items.find((item) => item.reference === newValue);
        if (item) {
          if (this.selectedItem.amount_currency) {
            this.calculateItemAmounts();
          } else {
            if (item.priceHT) {
              this.selectedItem.priceHT = item.priceHT;
            }
            if (item.priceTTC) {
              this.selectedItem.priceTTC = item.priceTTC;
            }
          }
        }
      }
    },
    "selectedItem.currency": function (newValue) {
      if (newValue === "MAD") {
        this.selectedItem.exchange_rate = 1;
      }
    },
    "selectedItem.exchange_rate": function (newValue) {
      // Auto-update if currency is MAD, exchange rate should be 1
      if (this.selectedItem.currency === "MAD") {
        this.selectedItem.exchange_rate = 1;
        return;
      }
      // Recalculate all amounts when exchange rate changes (only if not calculating and amount_currency exists)
      if (!this.isCalculating && this.selectedItem.amount_currency) {
        this.isCalculating = true;
        this.$nextTick(() => {
          this.calculateItemAmounts();
          this.isCalculating = false;
        });
      }
    },
    "selectedItem.amount_currency": function (newValue) {
      // Calculate all amounts automatically when amount in currency is entered
      if (newValue && !this.isCalculating) {
        this.$nextTick(() => {
          this.calculateItemAmounts();
        });
      } else if (!newValue) {
        // Clear related fields if amount is cleared
        this.selectedItem.priceHT = "";
        this.selectedItem.priceTTC = "";
      }
    },
    "selectedItem.quantity": function (newValue) {
      if (newValue && this.selectedItem.amount_currency) {
        this.calculateItemAmounts();
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("society/getAll");
    await this.$store.dispatch("cost/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("supplier/getAll");
    await this.$store.dispatch("consignment/show", this.reference);
  },
};
</script>
